import { defineMessages } from '@jutro/locale';

export default defineMessages({
    initiator: {
        id: 'ml.gateway.views.ActivityReports.mlPolicyChangesAdditionalFilter.Initiator',
        defaultMessage: 'Initiator'
    },
    allInitiators: {
        id: 'ml.gateway.views.ActivityReports.mlPolicyChangesAdditionalFilter.All Initiators',
        defaultMessage: 'All Initiators'
    }
});